import type { InvariantJiraRoute } from '@jira/platform__routing-route-types/src/InvariantJiraRoute.tsx';

export const softwareIncidentsNextGenRoute: InvariantJiraRoute = {
	name: 'software-incidents',
	path: '/jira/software/projects/:projectKey/incidents',
};
